
import { DataMapper } from '@/api/mappers/interfaces';
import { BusinessData } from './types';
import { Database } from '@/integrations/supabase/types';
import { Json } from '@/integrations/supabase/types';

// Database field types based on Supabase structure
export type BusinessDbFields = {
  id?: string;
  name: string;
  industry: string;
  industry_enum?: Database['public']['Enums']['business_industry'] | null;
  website?: string | null;
  description?: string | null;
  brand_voice?: string | null;
  target_audience?: string | null;
  company_size?: string | null;
  business_tags?: string[] | null;
  social_media?: Json | null;
  marketing_efforts?: string | null;
  brand_guidelines?: string | null;
  brand_guidelines_file_path?: string | null;
  last_analyzed_at?: number | null;
  is_onboarding_complete?: boolean;
  subscription_status?: string | null;
  plan_name?: string | null;
  current_period_end?: string | null;
  stripe_subscription_id?: string | null;
};

/**
 * Mapper implementation for Business data
 */
export const businessMapper: DataMapper<BusinessDbFields, BusinessData> = {
  toFrontend: (dbData: BusinessDbFields): BusinessData => ({
    id: dbData.id,
    name: dbData.name,
    industry: dbData.industry,
    industry_enum: dbData.industry_enum || undefined,
    website: dbData.website || '',
    description: dbData.description || '',
    brandVoice: dbData.brand_voice || undefined,
    targetAudience: dbData.target_audience || undefined,
    companySize: dbData.company_size || undefined,
    keywords: [], // Initialize with empty array
    businessTags: dbData.business_tags || [],
    socialMedia: dbData.social_media as Record<string, string> | undefined,
    marketingEfforts: dbData.marketing_efforts || undefined,
    brandGuidelines: dbData.brand_guidelines || undefined,
    brandGuidelinesFilePath: dbData.brand_guidelines_file_path || undefined,
    colors: [], // Initialize with empty array
    lastAnalyzedAt: dbData.last_analyzed_at || undefined,
    is_onboarding_complete: dbData.is_onboarding_complete || false,
    subscription_status: dbData.subscription_status || undefined,
    plan_name: dbData.plan_name || undefined,
    current_period_end: dbData.current_period_end || undefined,
    stripe_subscription_id: dbData.stripe_subscription_id || undefined,
  }),
  
  toDb: (frontendData: BusinessData): BusinessDbFields => ({
    id: frontendData.id,
    name: frontendData.name,
    industry: frontendData.industry,
    industry_enum: frontendData.industry_enum as Database['public']['Enums']['business_industry'] | null || null,
    website: frontendData.website || null,
    description: frontendData.description || null,
    brand_voice: frontendData.brandVoice || null,
    target_audience: frontendData.targetAudience || null,
    company_size: frontendData.companySize || null,
    business_tags: frontendData.businessTags || frontendData.keywords || null,
    social_media: frontendData.socialMedia as Json || null,
    marketing_efforts: frontendData.marketingEfforts || null,
    brand_guidelines: frontendData.brandGuidelines || null,
    brand_guidelines_file_path: frontendData.brandGuidelinesFilePath || null,
    last_analyzed_at: frontendData.lastAnalyzedAt || null,
    is_onboarding_complete: frontendData.is_onboarding_complete || false,
  })
};
